import { createTheme } from '@mui/material/styles';

export const fmobileTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0fb242',
      mainRGB: '15, 178, 66'
    },
    secondary: {
      // main: '#E79FB8',
      main: '#03fc14',
    },
  },
});
